<mat-form-field style="width: 140px;" >
  <mat-select panelClass="my-select"   [(ngModel)]="selectedTheme" (ngModelChange)="changeTheme()" appearance="standard" disableRipple>
    <mat-option *ngFor="let theme of themes" [value]="theme.value">
      {{ theme.label | translate }}
    </mat-option>
  </mat-select>
</mat-form-field>